<template>
<fragment>
    <p class="
    text-muted text-center" >
      <i class="feather icon-search display-4 d-block m-3"></i>
       - Nessuna risorsa trovata -
    </p>
</fragment>
</template>
<script>
export default {
  name: "noresult"}
  </script>